import { render, staticRenderFns } from "./PerformanceDetailPrecalification.vue?vue&type=template&id=b6c75e02&scoped=true"
import script from "./PerformanceDetailPrecalification.vue?vue&type=script&lang=js"
export * from "./PerformanceDetailPrecalification.vue?vue&type=script&lang=js"
import style0 from "./PerformanceDetailPrecalification.vue?vue&type=style&index=0&id=b6c75e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c75e02",
  null
  
)

export default component.exports